import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import ButtonTypes from 'components/Button/Button.const';

import CONTENT_TYPES from 'globalConst/contentTypes-const';
import FAVORITE_HOVER_TITLES from './ToggleFavoriteButton.const';
import Favourite from '../svg/Favourite';
import { isMobile } from 'util/device';
import { omit } from 'util/index';

/**
 * Toggle Favorites
 * @param {string} type
 * @param {object} item
 * @param {boolean} isFavorite
 * @param {function} toggleFavorite
 */

const ToggleFavoriteButton = ({
  item,
  isFavorite,
  toggleFavorite,
  withText,
  collectionTitle,
  handleToggle,
  isPodcastEpisodePage,
  listItem = false,
  isClip = false,
  isPodcast = false,
  ...restProps
}) => {
  if (isMobile || !item) {
    return null;
  }

  function toggle(e) {
    e.preventDefault();
    e.stopPropagation();
    toggleFavorite({
      ...item,
      collectionTitle,
      isPodcastEpisodePage,
      listItem,
      isClip,
      isPodcast,
    });
    if (collectionTitle === 'Mijn Podcasts') {
      handleToggle();
    }
  }

  let title;
  switch (item.contentTypeId) {
    case 'clip':
      title = isFavorite ? FAVORITE_HOVER_TITLES.CLIP[1] : FAVORITE_HOVER_TITLES.CLIP[0];
      break;
    default:
      title = null;
  }

  return (
    <Button
      onClick={toggle}
      title={title}
      type={withText ? ButtonTypes.PRIMARY : ButtonTypes.ICON}
      icon={<Favourite isActive={isFavorite} />}
      data-testid={`favorite-btn-${isFavorite ? 'active' : 'inactive'}`}
      text={withText && (isFavorite ? 'Toegevoegd' : 'Favorieten')}
      noHover
      {...omit(restProps, ['withAnalyticsData'])}
    />
  );
};

ToggleFavoriteButton.defaultProps = {
  isFavorite: false,
  withAnalyticsData: null,
  withText: false,
  isPodcastEpisodePage: false,
};

ToggleFavoriteButton.propTypes = {
  toggleFavorite: PropTypes.func.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string,
    contentTypeId: PropTypes.oneOf(Object.values(CONTENT_TYPES)),
    slug: PropTypes.string,
  }),
  isFavorite: PropTypes.bool,
  withAnalyticsData: PropTypes.object,
  withText: PropTypes.bool,
  collectionTitle: PropTypes.string,
  handleToggle: PropTypes.func,
  isPodcastEpisodePage: PropTypes.bool,
  listItem: PropTypes.bool,
  isClip: PropTypes.bool,
  isPodcast: PropTypes.bool,
};

ToggleFavoriteButton.displayName = 'ToggleFavoriteButton';

export default ToggleFavoriteButton;
